<template>
  <div>
    <logged-in-header />
    <configs-panel />
  </div>
</template>

<script>
import loggedInHeader from "../components/common/LoggedInHeader";
import configsPanel from "../components/configs/ConfigsPanel";

export default {
  components: {
    loggedInHeader,
    configsPanel
  }
};
</script>
